module.exports = __webpack_public_path__ + "static/img/english-logo.7c30e7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/english-logo.png
// module id = RI6J
// module chunks = 1